import { createAction } from '@reduxjs/toolkit';

export const changeFilter = createAction<{
  store: string;
  filter: string;
  value: any;
}>('pdp/changeFilter');
